module.exports = __webpack_public_path__ + "static/img/23_wendu.dc9c6f31.png";